import * as XLSX from 'xlsx';

// Excel Export Function
export const exportToExcel = (data: any[], filename: string = 'settlements_data') => {
  try {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    
    // Convert data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
    
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Settlements');
    
    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, `${filename}.xlsx`);
    
    return { success: true, message: 'Excel file exported successfully' };
  } catch (error) {
    console.error('Excel export error:', error);
    return { success: false, message: 'Failed to export Excel file' };
  }
};

// PDF Export Function (Simple table format)
export const exportToPDF = (data: any[]) => {
  try {
    // Create a simple HTML table for PDF content
    const tableHeaders = [
      'S.No',
      'Order Number', 
      'From User Type',
      'To User Type',
      'Transaction Category',
      'Amount (JOD)',
      'Type',
      'Status'
    ];

    let tableHTML = `
      <html>
        <head>
          <title>Settlements Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            h1 { color: #333; text-align: center; }
            .summary { margin-bottom: 20px; }
            .summary-item { margin: 5px 0; }
          </style>
        </head>
        <body>
          <h1>Settlements Report</h1>
          <div class="summary">
            <div class="summary-item"><strong>Generated on:</strong> ${new Date().toLocaleString()}</div>
            <div class="summary-item"><strong>Total Records:</strong> ${data.length}</div>
          </div>
          <table>
            <thead>
              <tr>
                ${tableHeaders.map(header => `<th>${header}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${data.map((row, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${row.orderId || 'N/A'}</td>
                  <td>${row.fromUserType || 'N/A'}</td>
                  <td>${row.toUserType || 'N/A'}</td>
                  <td>${row.transactionCategory || 'N/A'}</td>
                  <td>${row.amount || 'N/A'}</td>
                  <td>${row.transactionType || 'N/A'}</td>
                  <td>${row.status || 'N/A'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    // Create a new window with the HTML content
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(tableHTML);
      printWindow.document.close();
      
      // Wait for content to load then print
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 250);
      };
    }

    return { success: true, message: 'PDF ready for printing' };
  } catch (error) {
    console.error('PDF export error:', error);
    return { success: false, message: 'Failed to export PDF' };
  }
};

// Format data for export
export const formatDataForExport = (rawData: any[]) => {
  return rawData.map((item, index) => ({
    'S.No': index + 1,
    'Order Number': item.orderNumber || 'N/A',
    'From User Type': item.fromUserType || 'N/A',
    'To User Type': item.toUserType || 'N/A',
    'Transaction Category': item.transactionCategory || 'N/A',
    'Amount (JOD)': item.amount || 'N/A',
    'Type': item.transactionType || 'N/A',
    'Status': item.status || 'N/A',
    'Created Date': item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A',
    'Updated Date': item.updatedAt ? new Date(item.updatedAt).toLocaleDateString() : 'N/A'
  }));
};
